//core
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import format from "date-fns/format";
import { endOfDay, startOfDay } from "date-fns";
import { useSelector } from "react-redux";
import { useLocalStorage } from "usehooks-ts";
import {
  Box,
  SelectChangeEvent,
  useMediaQuery,
} from "@mui/material";

//styles
import { useStyles } from "./styles";

//constant
import { favoriteFilterKeys, statusOptions } from "../../../../constants";

//hooks
import { usePartners } from "../../../../../../../store/admin/partners/usePartners";
import { useFields } from "../../../../../../../store/common/fields/useFields";

//context
import { GlobalContext } from "../../../../../../../context/GlobalContext";

//components
import CDateRangePicker from "../../../../../../UI/Fields/CDateRangePicker";
import MuiAutocompleteSelectLazy from "../../../../../../UI/Fields/MuiAutocompleteSelectLazy";
import { IFlatFeeFilterDataType } from "../../../../types";
import MuiAutocompleteSelect from "../../../../../../UI/Fields/MuiAutocompleteSelect";
import {getDataIds} from "../../../../../Reports/utils";


interface IVisibleFilterProps {
  filter: IFlatFeeFilterDataType;
  setUpdateFilter: Dispatch<SetStateAction<IFlatFeeFilterDataType>>;
}

const VisibleFilter: React.FC<IVisibleFilterProps> = ({
  filter,
  setUpdateFilter,
}): JSX.Element => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const mobile = useMediaQuery('(max-width:767px)');

	const { getAffiliates } = usePartners();
	const { getTrackers, getBrands } = useFields();

	const context = useContext(GlobalContext);

  //favorite fields state
	const [favAdmFFStatuses, setFavAdmFFStatuses] = useLocalStorage<boolean>(favoriteFilterKeys.statuses, false);
	const [favAdmFFAffiliateIds, setFavAdmFFAffiliateIds] = useLocalStorage<boolean>(favoriteFilterKeys.affiliateIds, false);
	const [favAdmFFTrackerIds, setFavAdmFFTrackerIds] = useLocalStorage<boolean>(favoriteFilterKeys.trackerIds, false);
	const [favAdmFFBrandCodes, setFavAdmFFBrandCodes] = useLocalStorage<boolean>(favoriteFilterKeys.brandCodes, false);


	useEffect(() => {
    context.setAdmFlatFeeFilter(filter);
  }, [filter]);

	const fieldAffiliateIdsPayload = () => {
		return {
			chiefIds: null,
			departmentIds: null,
			status: 'approved'
		}
	};

	const fieldTrackerIdsPayload = () => {
		return {
			per_page: 100,
			...(!!filter?.affiliateIds.length ? { affiliateIds: getDataIds(filter.affiliateIds) } : {}),
		}
	};

  const favoriteFields = !mobile &&
  (favAdmFFStatuses || favAdmFFAffiliateIds || favAdmFFTrackerIds || favAdmFFBrandCodes)
    ? (
      <Box className={styles.favoriteFields}>
	      {favAdmFFAffiliateIds && (
		      <Box>
			      <MuiAutocompleteSelectLazy
				      keyValue="value"
				      keyId="id"
				      id="affiliateIds"
				      name="affiliateIds"
				      label={t(`admin.flatFee.filter.affiliateIds`)}
				      value={filter.affiliateIds}
				      multiple={true}
				      showSelectAll={false}
				      disabled={false}
				      getOptions={getAffiliates}
				      payloadData={fieldAffiliateIdsPayload()}
				      labelWithId={true}
				      onChange={setUpdateFilter}
				      disableCloseOnSelect={true}
				      showLabelCounter={true}
				      showNameInPayload={true}
			      />
		      </Box>
	      )}
	      {favAdmFFTrackerIds && (
		      <Box>
			      <MuiAutocompleteSelectLazy
				      keyValue="value"
				      keyId="id"
				      id="trackerIds"
				      name="trackerIds"
				      label={t(`admin.flatFee.filter.trackerIds`)}
				      value={filter.trackerIds}
				      multiple={true}
				      showSelectAll={false}
				      disabled={false}
				      getOptions={getTrackers}
				      payloadData={fieldTrackerIdsPayload()}
				      labelWithId={false}
				      onChange={setUpdateFilter}
				      disableCloseOnSelect={true}
				      showLabelCounter={true}
				      showNameInPayload={true}
			      />
		      </Box>
	      )}
	      {favAdmFFBrandCodes && (<>
		      <Box>
			      <MuiAutocompleteSelectLazy
				      keyValue="value"
				      keyId="id"
				      id="brandCodes"
				      name="brandCodes"
				      label={t("admin.flatFee.filter.brandCodes")}
				      value={filter.brandCodes}
				      multiple={true}
				      showSelectAll={false}
				      disabled={false}
				      getOptions={getBrands}
				      payloadData={{}}
				      labelWithId={true}
				      onChange={setUpdateFilter}
				      disableCloseOnSelect={true}
				      showLabelCounter={true}
				      showNameInPayload={true}
			      />
		      </Box>
	      </>)}
	      {favAdmFFStatuses && (<>
		      <Box>
			      <MuiAutocompleteSelect
				      keyValue="value"
				      keyId="id"
				      id="statuses"
				      name="statuses"
				      label={t("admin.flatFee.filter.statuses")}
				      value={filter.statuses}
				      multiple={true}
				      showSelectAll={false}
				      disabled={false}
				      staticOptions={statusOptions}
				      onChange={setUpdateFilter}
				      disableCloseOnSelect={true}
				      showLabelCounter={true}
				      prefix="admin.flatFee.form.options.statuses."
			      />
		      </Box>
	      </>)}

      </Box>
    ) : null;

  return (<>
	    {favoriteFields}
  </>);
};

export default VisibleFilter;
